export default "__VITE_ASSET__eae374ba__"